module.exports = __webpack_public_path__ + "static/img/RAKB_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAKB_1.png
// module id = OgXf
// module chunks = 0